import { useMemo } from 'react'
import { Select } from './select'
import { fmtPeriod } from '@/lib/format'

/** The current and previous `count - 1` Billing Periods, newest first (UTC). */
export function recentPeriods(count = 12): string[] {
  const now = new Date()
  return Array.from({ length: count }, (_, i) =>
    new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth() - i, 1)).toISOString().slice(0, 7),
  )
}

export function PeriodSelect({ value, onChange }: { value: string; onChange: (period: string) => void }) {
  const periods = useMemo(() => recentPeriods(), [])
  return (
    <Select
      ariaLabel="Billing Period"
      value={value}
      onValueChange={onChange}
      options={periods.map((p) => ({ value: p, label: fmtPeriod(p) }))}
    />
  )
}
